<template>
  <div>
    <el-image v-if="photoUrl"
              :preview-src-list="[photoUrl]"
              :fit="fit"
              :src="photoUrl"

    >
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"
           style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
      </div>
    </el-image>
    <el-image v-else>
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"
           style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
      </div>
    </el-image>
  </div>
</template>

<script>

export default {
  name: 'photoShow',
  props: {
    photoUrl: {},
  },

  computed: {

  },

  components: {

  },

  data() {
    return {
      style: {
        marginRight: this.interval
      }
    }
  },

  watch: {


  },


  methods: {

  },
};
</script>

<style scoped lang="scss">

</style>
